<template>
    <div v-if="canShow('经络风险评估') && info && jingluoList.length > 0">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">经络风险评估</div>
        </div>

        <div class="assessment">
            <div class="new-title">【 经络状态评估 】</div>
            <div class="chart-container chart-max">
                <div id="jingluoChart" class="jingluo-chart"></div>
            </div>

            <div class="table-mark">
                <table class="newre-table jingluo-table">
                    <thead>
                        <tr>
                            <th style="width: 30%;">经络</th>
                            <th style="width: 70%;">风险评估说明</th>
                        </tr>  
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in jingluoDescList" :key="'jl-' + index">
                            <td class="bold-text">{{ item.sysName }}({{ item.sysLevelDesc }})</td>
                            <td class="left-align-text">{{ item.sysDesc }}</td>
                        </tr>
                    </tbody>  
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { moduleMixin } from '../helpers';
import { pillar } from '../chart';
import { mapState } from 'vuex';

export default {
    name: 'ReportJingluoRisk',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info', 'page']),
        jingluoList() {
            const info = this.info || {};
            return Array.isArray(info.jingluo) ? info.jingluo : [];
        },
        jingluoDescList() {
            return this.jingluoList.filter(item => !!item.sysDesc);
        }
    },
    watch: {
        // 当翻页到经络页时，重绘 echarts 以防宽度计算不准
        page: {
            handler() {
                if (this.canShow('经络风险评估')) {
                    this.$nextTick(() => {
                        this.initChart();
                    });
                }
            },
            immediate: true
        }
    },
    methods: {
        initChart() {
            const dom = document.getElementById('jingluoChart');
            if (!dom) return;
            const list = this.jingluoList;
            const names = list.map(item => item.sysName.split('').join('\n'));
            const data = list.map(item => item.sysScore);
            pillar('jingluoChart', names, data);
        }
    }
};
</script>

<style lang="scss" scoped>
@import './JingluoRisk.scss';
</style>
